import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
@Component({
  selector: 'app-autorenew-confirmation',
  templateUrl: './autorenew.confirmation.component.html'
})
export class AutoRenewConfirmationComponent {
  @Input() submitted = false;
  @Input() form!: FormGroup;
}